export default {"src":"/_next/static/media/logotokkobroker_horiz_gris.615c031a.svg","height":267,"width":800,"blurWidth":0,"blurHeight":0};